import { render, staticRenderFns } from "./FactureTable.vue?vue&type=template&id=f27ec95e&"
import script from "./FactureTable.vue?vue&type=script&lang=js&"
export * from "./FactureTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports